
import { _genHash } from "./_genHash";
import { _getItemsAfterThisWidgetInThisRow } from "./_getItemsAfterThisWidgetInThisRow";
import { _getStartEndColumns } from './_getStartEndColumns';

export const handleAddWidget = ({
  currentFirstWidgetInRow,
  widgetIndex: _widgetIndex,
  config,
  setConfig,
  isNewRow,
  newWidgetBaseConf: _newWidgetBaseConf,
  TOTAL_COLUMNS
}) => {
  const newWidgetBaseConf = {
    comp: _newWidgetBaseConf.comp,
    props: {
      ...(_newWidgetBaseConf.props || {}),
    },
  };

  const modifiedConfig = JSON.parse(JSON.stringify(config));

  if (isNewRow) {
    modifiedConfig.push({
      id: _genHash(4),
      gridColumn: `1 / ${TOTAL_COLUMNS + 1}`,
      ...newWidgetBaseConf,
    });
    setConfig(modifiedConfig);
    return ({
      newWidgetIdx: modifiedConfig.length - 1,
    });
  }

  // calculate all the widgets in this row
  const [startCol, _endCol] = _getStartEndColumns(
    currentFirstWidgetInRow.gridColumn
  );

  let existingItemIndexes = [_widgetIndex];

  const itemsAfterIndexes = _getItemsAfterThisWidgetInThisRow({
    widgetIndex: _widgetIndex,
    endCol: _endCol,
    config,
    TOTAL_COLUMNS,
  });

  existingItemIndexes = [...existingItemIndexes, ...itemsAfterIndexes];

  // calculate space distribution and remainder space
  const newTotalWidgetsInRow = existingItemIndexes.length + 1;
  const spacePerWidget = Math.floor(TOTAL_COLUMNS / newTotalWidgetsInRow);
  const spaceForLastWidget =
    TOTAL_COLUMNS - existingItemIndexes.length * spacePerWidget; // since if total is not a multiple of TOTAL_COLUMNS, we will have uneven widths. this is to deal with that.

  // allocate standard space distribution space using grid column starting from 1 for the new widget. but dont add it yet to the config
  const gridColumnEndForNewWidget = 1 + spacePerWidget;

  // rest of the space distribution space can be assigned to the existing items except last.
  //last one gets remainder space

  existingItemIndexes.forEach((index, i) => {
    const thisWidgetStartColumn =
      gridColumnEndForNewWidget + i * spacePerWidget;
    if (i !== existingItemIndexes.length - 1) {
      //cuz we have to skip last item

      modifiedConfig[index].gridColumn = `${thisWidgetStartColumn} / ${
        thisWidgetStartColumn + spacePerWidget
      }`;
    } else {
      modifiedConfig[index].gridColumn = `${thisWidgetStartColumn} / ${
        thisWidgetStartColumn + spaceForLastWidget
      }`;
    }
  });

  // inject new item
  modifiedConfig.splice(existingItemIndexes[0], 0, {
    id: _genHash(4),
    gridColumn: `1 / ${gridColumnEndForNewWidget}`,
    ...newWidgetBaseConf,
  });

  // apply config
  // console.log({modifiedConfig: modifiedConfig.map(d => d.gridColumn)})
  setConfig(modifiedConfig);

  return {
    newWidgetIdx: existingItemIndexes[0],
  };
};